e360.filter('bool', function () {
   return function (input) {
      return input ? 'Yes' : 'No';
   };
});